<template>
    <div ref="swiperRef"
         class="swiper tariff-carousel"
    >
        <div class="swiper-wrapper">
            <TariffCard v-for="(item, index) in tariffs"
                        :key="index"
                        class="tariff-carousel__item swiper-slide"
                        :tariff="item"
                        stretch-on-mobile
                        :subscription-index="subscriptionIndex"
            />
        </div>
        <div class="tariff-carousel__pagination" />
    </div>
</template>

<script setup lang="ts">
    import type { SwiperOptions } from 'swiper/types'
    import type { TariffItem } from '~/src/shared/components/pages/index/mock/indexTariff'
    import { Pagination } from 'swiper/modules'
    import TariffCard from '~/src/entities/tariff-card/TariffCard.vue'
    import { useSwiper } from '~/src/shared/composables/client/slider/useSwiper'

    defineProps<{
        tariffs: TariffItem[]
        subscriptionIndex?: number
    }>()

    const swiperRef = ref<HTMLElement | null>(null)
    const swiperOptions: SwiperOptions = {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 12,
        autoHeight: true,
        pagination: {
            el: '.tariff-carousel__pagination',
            clickable: true,
            type: 'bullets',
        },

        breakpoints: {
            768: {
                slidesPerView: 'auto',
                autoHeight: false,
            },
        },
    }

    useSwiper(swiperRef, swiperOptions)
</script>

<style scoped lang="scss">
    .tariff-carousel {
        &__swiper {
            @include respond-to(mobile) {
                position: relative;
                overflow: visible;
            }
        }

        &__pagination {
            display: none;

            @include respond-to(mobile) {
                display: block;
                margin-top: 12px;
                text-align: center;
            }

            :deep(.swiper-pagination-bullet) {
                display: inline-block;
                width: 10px;
                height: 10px;
                margin: 0 5px;
                border-radius: 50%;
                background-color: var(--blue-100);
            }

            :deep(.swiper-pagination-bullet-active) {
                background-color: var(--blue-600);
            }
        }
    }
</style>
